var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect7, _path8, _rect8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeisibotmm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 273,
    viewBox: "0 0 258 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.9171,
    y: 4.28234,
    width: 164.585,
    height: 129.839,
    rx: 14.56,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 8.56468
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6027,
    y: 11.2316,
    width: 147.212,
    height: 115.941,
    rx: 14.56,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 8.56468
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0098,
    y: 27.2178,
    width: 116.398,
    height: 83.3898,
    rx: 18.8423,
    fill: "#FDFFF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9171,
    y: 4.28234,
    width: 164.585,
    height: 129.839,
    rx: 14.56,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 8.56468
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6027,
    y: 11.2316,
    width: 147.212,
    height: 115.941,
    rx: 14.56,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 8.56468
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0098,
    y: 27.2178,
    width: 116.398,
    height: 83.3898,
    rx: 18.8423,
    fill: "#FDFFF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.911,
    cy: 58.4882,
    r: 11.0028,
    fill: "#280003"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.766,
    cy: 58.4882,
    r: 11.0028,
    fill: "#280003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.81 88.3119C128.81 89.5741 128.098 90.8237 126.714 91.9887C125.331 93.1537 123.304 94.2109 120.75 95.0993C118.196 95.9876 115.166 96.6896 111.835 97.1646C108.504 97.6396 104.938 97.8782 101.343 97.8666C97.7482 97.855 94.1953 97.5936 90.8897 97.0972C87.5841 96.6009 84.5913 95.8796 82.0843 94.9749C79.5772 94.0703 77.6056 93.0002 76.2831 91.8266C74.9607 90.6529 74.3137 89.3989 74.3796 88.1369L85.9529 88.2114C85.9151 88.9366 86.2869 89.6573 87.0469 90.3318C87.8069 91.0063 88.9401 91.6213 90.3809 92.1412C91.8217 92.6612 93.5417 93.0757 95.4415 93.3609C97.3412 93.6462 99.3831 93.7965 101.449 93.8031C103.515 93.8098 105.565 93.6726 107.479 93.3996C109.393 93.1267 111.135 92.7232 112.602 92.2127C114.07 91.7021 115.235 91.0945 116.03 90.425C116.825 89.7555 117.235 89.0373 117.235 88.3119H128.81Z",
    fill: "#280003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.295 163.886L148.808 164.735L149.657 166.222L151.962 170.258C158.294 181.349 172.419 185.206 183.51 178.873L192.575 173.697L194.062 172.848L193.213 171.36L180.291 148.73L179.441 147.243L177.954 148.092L150.295 163.886Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.84 147.844L180.991 146.357L182.478 145.507L191.279 140.482C198.35 136.445 207.354 138.904 211.392 145.974C215.429 153.045 212.97 162.05 205.9 166.087L197.099 171.112L195.612 171.962L194.762 170.474L181.84 147.844Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6406 137.246H166.779V222.899C166.779 226.446 163.903 229.322 160.356 229.322H44.0641C40.5165 229.322 37.6406 226.446 37.6406 222.899V137.246Z",
    fill: "#280003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9598 146.249H155.46V217.108C155.46 218.882 154.022 220.32 152.248 220.32H52.1716C50.3978 220.32 48.9598 218.882 48.9598 217.108V146.249Z",
    fill: "#C2D1D4",
    stroke: "#FFFEF2",
    strokeWidth: 6.42351
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.872 46.1519H196.434C199.982 46.1519 202.858 49.0278 202.858 52.5754V91.0393C202.858 94.5869 199.982 97.4628 196.434 97.4628H186.872V46.1519Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 4.28234
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1264 43.2574H11.5811C6.36716 43.2574 2.14039 47.4841 2.14039 52.6981V85.1275C2.14039 90.3415 6.36715 94.5683 11.5811 94.5683H18.1264V43.2574Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 4.28234
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.7607,
    y: 229.648,
    width: 40.4637,
    height: 20.7744,
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 5.13881
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6832 253.065V251.352H94.9702H54.8909C49.2147 251.352 44.6132 255.954 44.6132 261.63V268.701V270.414H46.3262H94.9702H96.6832V268.701V253.065Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 3.42587
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5694,
    y: -2.5694,
    width: 40.4637,
    height: 20.7744,
    transform: "matrix(-1 0 0 1 152.809 232.218)",
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 5.13881
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.315 253.065V251.352H110.028H150.107C155.783 251.352 160.385 255.954 160.385 261.63V268.701V270.414H158.672H110.028H108.315V268.701V253.065Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 3.42587
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3543 149.986V148.273H37.6414H32.9937C20.2223 148.273 9.8691 158.627 9.8691 171.398V181.837V183.55H11.582H37.6414H39.3543V181.837V149.986Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6414 185.335H39.3543V187.048V197.182C39.3543 205.324 32.7538 211.925 24.6117 211.925C16.4696 211.925 9.8691 205.324 9.8691 197.182V187.048V185.335H11.582H37.6414Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.801 108.931C255.335 109.58 255.253 110.543 254.617 111.098C248.212 116.689 216.776 144.13 207.812 151.955C207.184 152.503 206.363 152.775 205.536 152.709C204.709 152.642 203.945 152.243 203.417 151.601C203.417 151.601 203.417 151.601 203.417 151.601C202.889 150.959 202.642 150.129 202.731 149.298C202.82 148.468 203.239 147.707 203.892 147.187C213.115 139.849 245.254 114.277 252.307 108.666C253.072 108.057 254.176 108.172 254.794 108.923C254.797 108.926 254.799 108.928 254.801 108.931Z",
    fill: "#1388D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.779 108.115C256.751 109.297 256.603 111.048 255.445 112.058L208.64 152.915C207.753 153.689 206.595 154.073 205.428 153.979C204.261 153.885 203.183 153.322 202.439 152.417C201.694 151.511 201.345 150.34 201.471 149.168C201.597 147.996 202.188 146.922 203.109 146.189L251.524 107.668C252.83 106.629 254.717 106.824 255.773 108.108L255.779 108.115ZM253.823 109.746L253.816 109.739C253.636 109.519 253.314 109.486 253.09 109.664L204.675 148.186C204.29 148.492 204.044 148.94 203.991 149.429C203.938 149.918 204.084 150.407 204.395 150.785C204.706 151.163 205.156 151.399 205.644 151.438C206.131 151.477 206.614 151.317 206.985 150.994L253.789 110.137C253.904 110.037 253.919 109.864 253.823 109.746Z",
    fill: "#280003"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.779 108.115C256.751 109.297 256.603 111.048 255.445 112.058L208.64 152.915C207.753 153.689 206.595 154.073 205.428 153.979C204.261 153.885 203.183 153.322 202.439 152.417C201.694 151.511 201.345 150.34 201.471 149.168C201.597 147.996 202.188 146.922 203.109 146.189L251.524 107.668C252.83 106.629 254.717 106.824 255.773 108.108L255.779 108.115ZM253.823 109.746L253.816 109.739C253.636 109.519 253.314 109.486 253.09 109.664L204.675 148.186C204.29 148.492 204.044 148.94 203.991 149.429C203.938 149.918 204.084 150.407 204.395 150.785C204.706 151.163 205.156 151.399 205.644 151.438C206.131 151.477 206.614 151.317 206.985 150.994L253.789 110.137C253.904 110.037 253.919 109.864 253.823 109.746Z",
    fill: "#280003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeisibotmm);
export default __webpack_public_path__ + "static/media/keisibotmm.bfd1bd3557bdf25a4f0ae0c4ef1a8ad7.svg";
export { ForwardRef as ReactComponent };